import React from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import $ from 'jquery';
import { cancelarPedidoStoneConnect } from '../../actions/reserva/actionsReserva';
import { showSuccessMsg, showErrorMsg } from '../../util/messagesUtil';

// Item "Cancelar envio Stone Connect" (Gerenciar Pedidos) -- diferente do botão em Vender
// Passagens (que dispara direto, sem confirmação), aqui tem diálogo de confirmação porque o
// operador pode estar mexendo num pedido de outro atendimento/outro dia, não o que acabou de
// criar. Ver plano em demanda-a-fazer/stone-connect-cancelamento-pedido-pendente/.
export class ModalCancelarEnvioStoneConnect extends React.Component {
  fecharModal () {
    $('#modalCancelarEnvioStoneConnect')
      .modal('hide');
    $('#modalCancelarEnvioStoneConnect')
      .hide();
    $('.modal-backdrop')
      .hide();
  }

  confirmar () {
    this.props.cancelarPedidoStoneConnect(this.props.pedido.id, this.props.empresaSelecionada.id)
      .then(() => {
        showSuccessMsg('Envio para a maquininha cancelado.');
        this.fecharModal();
        this.props.buscarPedidos();
      })
      .catch((error) => {
        const texto = error.response && error.response.data && error.response.data.mensagens
          ? error.response.data.mensagens[0].mensagem
          : 'Não foi possível cancelar o envio para a Stone Connect. Tente novamente.';
        showErrorMsg(texto);
      });
  }

  render () {
    return (
      <div className="modal fade" id="modalCancelarEnvioStoneConnect" tabIndex="-1" role="dialog"
           aria-labelledby="modalCancelarEnvioStoneConnect" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content" style={{ borderRadius: '12px', overflow: 'hidden', border: 'none' }}>

            <div className="vx-modal-header">
              <div className="vx-modal-title">
                <span className="material-icons">cancel</span>
                Cancelar envio Stone Connect
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Fechar">
                <span className="material-icons">close</span>
              </button>
            </div>

            <div className="vx-modal-body">
              <p>Isso cancela o envio à maquininha enquanto o pagamento ainda não foi confirmado.</p>
              <p><b>Isso NÃO cancela e NÃO estorna automaticamente as Cobranças que já foram
                capturadas e aprovadas.</b></p>
              <p>Deseja continuar?</p>
            </div>
            <div className="vx-modal-footer">
              <button type="button" className="vx-modal-btn-fechar" data-dismiss="modal">
                Não
              </button>
              <button type="button" className="vx-modal-btn-confirmar" style={{ background: '#e53935' }}
                      onClick={() => this.confirmar()}>
                <span className="material-icons" style={{ fontSize: '16px' }}>check_circle</span>
                Sim, cancelar envio
              </button>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export const mapStateToProps = state => ({
  pedido: state.pedido,
  empresaSelecionada: state.empresaSelecionada,
});

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    cancelarPedidoStoneConnect,
  }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(ModalCancelarEnvioStoneConnect);
